export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              OlmezMobilya
            </h3>
            <p className="text-gray-400 leading-relaxed mb-4">
              Kaliteli mobilya çözümleri ile evinize değer katıyoruz. Mutfak dolabı, gardırop, yatak odası takımı ve daha fazlası.
            </p>
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              +90 530 303 02 18
            </a>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Adres</h4>
            <div className="flex items-start gap-2 text-gray-400">
              <i className="ri-map-pin-line text-amber-400 text-xl mt-1"></i>
              <p className="leading-relaxed">
                Hacıbey Mahallesi<br />
                Yeni Sanayi Çarşısı<br />
                Endüstri Cad No: 20<br />
                Nallıhan/ANKARA
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Ürünlerimiz</h4>
            <ul className="space-y-2">
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Mutfak Dolabı</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Tüm Tezgah Çeşitleri</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Yüklük</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Gardırop</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Vestiyer</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Giyinme Odası</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Ana Sayfa</a></li>
              <li><a href="#products" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Ürünler</a></li>
              <li><a href="#about" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">Hakkımızda</a></li>
              <li><a href="#contact" className="hover:text-amber-400 transition-colors duration-200 cursor-pointer">İletişim</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            © {currentYear} OlmezMobilya. Tüm hakları saklıdır. | 
            <a 
              href="https://www.webkitdesign.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-amber-400 hover:text-amber-300 ml-1 cursor-pointer"
            >
              Designed by Webkitdesign
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}